import { useI18n } from 'contexts/i18n';
import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { cartService } from 'services';
import { displayNotification } from 'utils';

export const useEmptyCart = () => {
  const i18n = useI18n();
  const queryClient = useQueryClient();
  return useMutation(
    () => {
      return cartService.emptyCart();
    },
    {
      onSuccess: (data, variables, context) => {
        queryClient.setQueriesData([ServerStateKeysEnum.userCurrentCart], data);
      },
      onError: () => {
        displayNotification(i18n['Failed to empty Cart!'], 'danger');
      },
    }
  );
};
